import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CarIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M19.96 17.1C19.96 18.2 19.08 19.1 17.98 19.1C17.12 19.1 16.24 18.58 16.02 17.5H7.98C7.76 18.58 6.88 19.1 6.02 19.1C4.92 19.1 4.04 18.2 4.04 17.1V11.26L4.52 10.28H3.08V8.68H5.28L6.96 5.2H17.04L18.72 8.68H20.92V10.28H19.48L19.96 11.26V17.1ZM6.38 9.8H17.62L16.1 6.7H7.9L6.38 9.8ZM17.12 16.8C17.12 17.18 17.4 17.48 17.78 17.48C18.16 17.48 18.46 17.18 18.46 16.8V11.3H5.54V16.8C5.54 17.18 5.84 17.48 6.22 17.48C6.6 17.48 6.88 17.18 6.88 16.8V16H17.12V16.8ZM12 13.52C12.76 13.52 13.42 13.14 13.84 12.56H16.92V14.06H14.42C13.76 14.62 12.92 14.98 12 14.98C11.08 14.98 10.24 14.62 9.58 14.06H7.08V12.56H10.16C10.58 13.14 11.24 13.52 12 13.52Z" />
    </SvgIcon>
  );
});
